import React from 'react'
import styled from 'styled-components'

export default ({ sections, openSection }) => (
  <SectionContainer>
    {
      sections.map((section, idx) => (
          <Section
            key={idx}
            background={section.image}
            onClick={() => openSection(section.id)}
          >
            <Icon src={section.icon}/>
            <Title>{section.name}</Title>
            <Description>{section.title}</Description>
          </Section>
        )
      )
    }
  </SectionContainer>
)

const SectionContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  
  @media all and (max-width: 700px) {
    flex-direction: column;
  }
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: url(${props => props.background});
  background-repeat: no-repeat;
  background-size: cover;
  height: 170px;
  flex-basis: 45%;
 
  margin-bottom: 1rem;
  border-radius: 5px;
  padding: 1rem;
  color: #fff;
  cursor: pointer;
  opacity: .9;
  transition: all .2s linear;
  
  &:hover {
    opacity: 1
  }
  
  &:nth-of-type(n+1) {
    margin-right: 1rem;
    
    @media all and (max-width: 700px) {
      margin-right: 0;
    }
  }
  
  @media all and (max-width: 700px) {
    flex-basis: 100%;
  }
`

const Icon = styled.img`
  width: 48px;
`

const Title = styled.h4`
  margin: .7rem 0;
`

const Description = styled.p`

`
